import {mapRecordToItems} from "@/helpers/mapRecordToItems.helper";

export enum ScheduledProductSeriesFields {
    NAME = 'name',
    ITEMS = 'items',
    RELATED_TO = 'relatedTo',
    AUTO_INCREMENT = 'autoIncrement',
    IS_ACTIVE = 'isActive',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace ScheduledProductSeriesFields {
    type Data = {
        text: string;
        readOnly?: true;
        updateOnly?: true;
    }

    export const Record: Record<ScheduledProductSeriesFields, Data> = {
        [ScheduledProductSeriesFields.NAME]: {
            text: 'Name',
        },
        [ScheduledProductSeriesFields.ITEMS]: {
            text: 'Elemente',
        },
        [ScheduledProductSeriesFields.RELATED_TO]: {
            text: 'In Verbindung mit',
        },
        [ScheduledProductSeriesFields.AUTO_INCREMENT]: {
            text: 'Automatischer Versand',
        },
        [ScheduledProductSeriesFields.IS_ACTIVE]: {
            text: 'Aktivitätsstatus',
        },
        [ScheduledProductSeriesFields.CREATED_AT]: {
            text: 'Erzeugungsdatum',
            readOnly: true,
        },
        [ScheduledProductSeriesFields.UPDATED_AT]: {
            text: 'Aktualisierungsdatum',
            readOnly: true,
        },
    };

    export const Items = mapRecordToItems(Record);
}
